import React from 'react';
import ReportsTableSummary, { allAppsWidth } from "../../Common/ReportsTableSummary";
import { getReportColumnsForSeries } from "../SalesOrEvaluations.utils";
import { headerConfigBasedOnReportBy } from "../SalesOrEvaluationsHead";
export default function SalesOrEvaluationsSummary(props) {
  const {
    totalSeries,
    reportBy,
    reportName
  } = props;
  const reportColumns = getReportColumnsForSeries(totalSeries.series, reportName, reportBy);
  const summary = [{
    head: 'All apps',
    width: "".concat(allAppsWidth, "%")
  }];
  const headersConfig = [...headerConfigBasedOnReportBy[reportBy], "All ".concat(reportName)];
  headersConfig.map((head, index) => summary.push({
    head,
    content: reportColumns[index].content,
    width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
  }));
  return /*#__PURE__*/React.createElement(ReportsTableSummary, {
    summary: summary
  });
}